import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Secured from './Secured';
import reportWebVitals from './reportWebVitals';
import { msalConfig } from './Utils/authConfig';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { Provider } from 'react-redux';
import store from './redux/store';
const msalInstance = new PublicClientApplication(msalConfig);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
     <MsalProvider instance={msalInstance}>
        <Provider store={store}>
          <Secured />
        </Provider>
     </MsalProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
